export default __webpack_public_path__ + "static/media/job_offer4_xl.027450bf.jpg";